export type T = DomainObject
type DomainObject = Custom<string, string | number | boolean | any>

export type Relation = 'parent' | 'child' // | 'property'

export type Custom<Names extends string, Value extends AttributeValue> = Readonly<{
  id: string
  type: string
  links: Link[]
  attributes: Attributes<Names, Value>
}>

type Link = { rel: Relation, to: string }

type AttributeValue = string | number | boolean | {[name: string] : AttributeValue }
type Attributes<Name extends string, Value extends AttributeValue> = Record<Name, Value>

// type Attributes<Name extends string, Value extends string | number | boolean | any> = Record<Name, Value>

export const typeOf = ({ type }: DomainObject): string => type
export const idOf = ({ id }: DomainObject): string => id
export const attributesOf = ({ attributes }: DomainObject): Attributes<string, any> => attributes
export const labelOf = (domainObject: DomainObject): string =>
  attributesOf(domainObject).name
  || `${typeOf(domainObject)}#${idOf(domainObject)}`
export const linksOf = ({ links }: DomainObject): Link[] => links ?? []
